import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box mb="18px">
      <Typography
        variant="caption"
        sx={{
          color: colors.primary[100],
          fontWeight: 800,
          textTransform: "uppercase",
        }}
      >
        Hill Group
      </Typography>
      <Typography
        variant="h2"
        color={colors.grey[100]}
        sx={{ lineHeight: 1.15, mb: "4px" }}
      >
        {title}
      </Typography>
      <Typography variant="h6" color={colors.grey[500]}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
